import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGavel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "m14.5 12.5-8 8a2.12 2.12 0 1 1-3-3l8-8" }),
		/* @__PURE__ */ _jsx("path", { d: "m16 16 6-6" }),
		/* @__PURE__ */ _jsx("path", { d: "m8 8 6-6" }),
		/* @__PURE__ */ _jsx("path", { d: "m9 7 8 8" }),
		/* @__PURE__ */ _jsx("path", { d: "m21 11-8-8" })
	]
});
const ForwardRef = forwardRef(SvgGavel);
export default ForwardRef;
